export const isEmpty = (exp) =>
  exp === null ||
  exp === undefined ||
  (typeof exp === "object" &&
    !Array.isArray(exp) &&
    Object.keys(exp).length === 0);

export const isLiteral = (exp) =>
  typeof exp === "string" ||
  typeof exp === "number" ||
  typeof exp === "boolean";
